var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "stepper" } }, [
    _c("div", { staticClass: "stepper-container" }, [
      _c(
        "div",
        { staticClass: "item-container" },
        _vm._l(_vm.tabInfo, function (tab, index) {
          return _c(
            "div",
            {
              key: index,
              class:
                index === _vm.activeTab
                  ? "item active"
                  : "item" && tab.isComplete
                  ? "item complete"
                  : "item",
              on: {
                click: function ($event) {
                  return _vm.itemClickHandler(index)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "logo",
                  class: { completed: _vm.isCompleted(index) },
                },
                [
                  _vm.isCompleted(index)
                    ? _c("div", [_vm._v(_vm._s(index + 1))])
                    : _c("DynamicSvg", { attrs: { name: tab.logo } }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(tab.title) +
                    "\n                "
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }